/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SecReviewSREntityResult } from './SecReviewSREntityResult';
import {
    SecReviewSREntityResultFromJSON,
    SecReviewSREntityResultFromJSONTyped,
    SecReviewSREntityResultToJSON,
} from './SecReviewSREntityResult';

/**
 * 
 * @export
 * @interface SecReviewSREntityPagedResponse
 */
export interface SecReviewSREntityPagedResponse {
    /**
     * 
     * @type {number}
     * @memberof SecReviewSREntityPagedResponse
     */
    total: number;
    /**
     * 
     * @type {Array<SecReviewSREntityResult>}
     * @memberof SecReviewSREntityPagedResponse
     */
    results: Array<SecReviewSREntityResult>;
    /**
     * 
     * @type {number}
     * @memberof SecReviewSREntityPagedResponse
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof SecReviewSREntityPagedResponse
     */
    page_size: number;
}

/**
 * Check if a given object implements the SecReviewSREntityPagedResponse interface.
 */
export function instanceOfSecReviewSREntityPagedResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "total" in value;
    isInstance = isInstance && "results" in value;
    isInstance = isInstance && "page" in value;
    isInstance = isInstance && "page_size" in value;

    return isInstance;
}

export function SecReviewSREntityPagedResponseFromJSON(json: any): SecReviewSREntityPagedResponse {
    return SecReviewSREntityPagedResponseFromJSONTyped(json, false);
}

export function SecReviewSREntityPagedResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SecReviewSREntityPagedResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total': json['total'],
        'results': ((json['results'] as Array<any>).map(SecReviewSREntityResultFromJSON)),
        'page': json['page'],
        'page_size': json['page_size'],
    };
}

export function SecReviewSREntityPagedResponseToJSON(value?: SecReviewSREntityPagedResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total': value.total,
        'results': ((value.results as Array<any>).map(SecReviewSREntityResultToJSON)),
        'page': value.page,
        'page_size': value.page_size,
    };
}

